module.exports = __webpack_public_path__ + "assets/img/img130.03ed0727.png";